export enum AddressType {
  shipping = 0,
  mailing = 1,
}
